module.exports = __webpack_public_path__ + "media/images/logo-amazing-health-46abc2af16dbbb3f47956f7c2c15a0d5.png";